module.exports = __webpack_public_path__ + "media/img/illustrations/scale-979e77df5ce27fb89d44294e81a4d40d.svg";